/* vx-sachet-story.js (WS-VISUALS): drives the pinned "day in the life of one sachet" story. Vanilla, no libs.
   All state is a pure function of scroll progress p (0..1), so it scrubs both ways. Static stacked story when reduced motion / no IO. */
(function () {
  var root = document.querySelector('[data-vx-story]');
  if (!root || !root.classList.contains('vx-live')) return;
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var arts = [].slice.call(root.querySelectorAll('[data-vx-beat]'));
  var cv = root.querySelector('.vx-fx'), ctx = cv && cv.getContext('2d');
  var rail = root.querySelector('.vx-rail'), fill = root.querySelector('.vx-fill');
  var lis = [].slice.call(root.querySelectorAll('.vx-rail li'));
  var tot = 0, acc = 0, X = 0.028;
  arts.forEach(function (a) { tot += +a.getAttribute('data-w') || 1; });
  var sc = arts.map(function (a, i) {
    var w = +a.getAttribute('data-w') || 1, s = acc / tot; acc += w;
    var o = { i: i, s: s, e: acc / tot, g: +a.getAttribute('data-g') || 1, key: a.getAttribute('data-key'),
      fig: a.querySelector('.vx-fig'), img: a.querySelector('.vx-fig img'), cap: a.querySelector('.vx-cap'), op: i ? 0 : 1 };
    if (o.cap && 'inert' in o.cap) o.cap.inert = !!i;
    return o;
  });
  var G = {}; sc.forEach(function (o) { var g = G[o.g] = G[o.g] || { s: o.s, e: o.e }; g.s = Math.min(g.s, o.s); g.e = Math.max(g.e, o.e); });
  var gk = Object.keys(G).map(Number).sort(function (a, b) { return a - b; }), nG = gk.length;

  /* particle paths: normalised cubic-bezier chains in the media box; [points, colour] */
  var PATHS = {
    /* tear frame: pouch lies flat, nothing is poured, so no particle path (overlay skipped for it) */
    sprinkle: [[[.47, 0], [.44, .25], [.5, .45], [.5, .64], [.5, .66], [.66, .5], [.88, .3], [1.05, .08]], '#F7E3B0', 30],
    gut: [[[.55, 1.04], [.95, .86], [.05, .72], [.55, .52], [.95, .34], [.35, .2], [.55, -.04]], '#C2ED97', 34],
    coat: [[[.5, 1.05], [.3, .85], [.7, .7], [.5, .5]], '#F6D58A', 26],
    calm: [[[1.05, .1], [.85, .3], [.6, .45], [.5, .62]], '#CEC7F4', 22],
    mouth: [[[-.05, .95], [.2, .8], [.35, .6], [.45, .45]], '#C2ED97', 26],
    dusk: [[[.2, 1.02], [.3, .7], [.7, .5], [.8, .1]], '#F7E3B0', 10],
    pack: [[[.1, 1.02], [.3, .7], [.6, .5], [.9, .08]], '#C2ED97', 14]
  };
  var mob = matchMedia('(max-width:860px)').matches, sprites = {}, W = 0, H = 0, dpr = 1;
  function sprite(c) {
    if (sprites[c]) return sprites[c];
    var k = document.createElement('canvas'); k.width = k.height = 32; var x = k.getContext('2d'), g = x.createRadialGradient(16, 16, 0, 16, 16, 16);
    g.addColorStop(0, '#fff'); g.addColorStop(.25, c); g.addColorStop(1, 'rgba(255,255,255,0)'); x.fillStyle = g; x.fillRect(0, 0, 32, 32);
    return (sprites[c] = k);
  }
  function bez(pts, u) {
    var n = (pts.length - 1) / 3, f = u * n, k = Math.min(n - 1, f | 0), t = f - k, a = pts[3 * k], b = pts[3 * k + 1], c = pts[3 * k + 2], d = pts[3 * k + 3], m = 1 - t;
    return [m * m * m * a[0] + 3 * m * m * t * b[0] + 3 * m * t * t * c[0] + t * t * t * d[0], m * m * m * a[1] + 3 * m * m * t * b[1] + 3 * m * t * t * c[1] + t * t * t * d[1]];
  }
  function size() {
    if (!cv) return; var r = cv.getBoundingClientRect(); dpr = Math.min(window.devicePixelRatio || 1, mob ? 1.5 : 2);
    W = r.width; H = r.height; cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
  }
  function draw(t, p) {
    if (!ctx || !W) return;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, W, H); ctx.globalCompositeOperation = 'lighter';
    sc.forEach(function (o, i) {
      var P = PATHS[o.key]; if (!P) return;
      var nx = sc[i + 1], a = o.op * (nx ? 1 - nx.op : 1); if (a < .02) return;
      var N = Math.round(P[2] * (mob ? .6 : 1)), sp = sprite(P[1]), pts = P[0], loc = clamp((p - o.s) / (o.e - o.s), 0, 1);
      for (var n = 0; n < N; n++) {
        var base = (n / N + t * .00011 + p * 2.2 + (n % 3) * .013) % 1;
        for (var e = 0; e < 3; e++) { /* head + 2 trail echoes */
          var u = base - e * .012; if (u < 0) u += 1;
          var q = bez(pts, u), wob = Math.sin(t * .002 + n * 1.7 + u * 9) * .012, al = a * Math.pow(Math.sin(Math.PI * u), .7) * (e ? .32 / e : 1);
          var s = (mob ? 11 : 14) * (e ? .7 : 1) * (.6 + .6 * ((n * 7) % 5) / 4);
          ctx.globalAlpha = clamp(al, 0, 1); ctx.drawImage(sp, q[0] * W + wob * W - s / 2, q[1] * H - s / 2, s, s);
        }
      }
      if (o.key === 'coat' || o.key === 'calm' || o.key === 'mouth') { /* soft target pulse where the stream lands */
        var end = pts[pts.length - 1], r = (28 + 10 * Math.sin(t * .003)) * (mob ? .8 : 1);
        ctx.globalAlpha = a * .5 * (.5 + .5 * loc); ctx.drawImage(sp, end[0] * W - r, end[1] * H - r, r * 2, r * 2);
      }
    });
    ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
  }
  var p = 0, vis = false, inV = false, raf = 0, cur = -1;
  function go() { vis = inV && !document.hidden; if (vis && !raf) raf = requestAnimationFrame(loop); }
  function update(t) {
    var r = root.getBoundingClientRect(), span = r.height - innerHeight;
    p = span > 0 ? clamp(-r.top / span, 0, 1) : 0;
    var act = 0;
    sc.forEach(function (o, i) {
      o.op = i ? clamp((p - (o.s - X)) / (2 * X), 0, 1) : 1;
      var tl = clamp((p - o.s) / (o.e - o.s), 0, 1);
      if (o.op > 0 && p < o.e + X + .06) { /* Ken Burns + parallax, only while the layer can be seen */
        var kb = i % 2 ? 1 - tl : tl;
        o.fig.style.opacity = o.op;
        o.img.style.transform = 'translate3d(0,' + ((tl - .5) * -14).toFixed(1) + 'px,0) scale(' + (1.05 + .06 * kb).toFixed(4) + ')';
      } else if (i && o.op === 0) o.fig.style.opacity = 0;
      if (p >= o.s - 1e-6) act = i;
    });
    if (act !== cur) {
      sc.forEach(function (o, i) { o.cap.classList.toggle('is-on', i === act); if ('inert' in o.cap) o.cap.inert = i !== act; });
      cur = act;
    }
    /* progress line: piecewise per beat group so the Fresh Green fill and labels match the scenes */
    var gi = sc[act].g, gIdx = gk.indexOf(gi), gg = G[gi], lt = clamp((p - gg.s) / (gg.e - gg.s), 0, 1);
    if (fill) fill.style.transform = 'scaleX(' + ((gIdx + lt) / nG).toFixed(4) + ')';
    lis.forEach(function (l, i) { l.classList.toggle('is-on', i <= gIdx); });
    draw(t, p);
  }
  function loop(t) { raf = 0; if (!vis) return; update(t); raf = requestAnimationFrame(loop); }
  new IntersectionObserver(function (en) {
    inV = en[0].isIntersecting; go();
  }, { rootMargin: '100px 0px' }).observe(root);
  size(); addEventListener('resize', function () { mob = matchMedia('(max-width:860px)').matches; size(); }, { passive: true });
  if (window.ResizeObserver && cv) new ResizeObserver(size).observe(cv);
  document.addEventListener('visibilitychange', go);
  root.setAttribute('data-ready', '1');
  update(performance.now());
})();
